import { Capacitor, registerPlugin } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";

type TripAiFilePlugin = {
  saveBase64ToDownloads(options: { fileName: string; mimeType: string; data: string }): Promise<{ uri?: string; path?: string; bytes?: number }>;
};

const NativeFile = registerPlugin<TripAiFilePlugin>("TripAiFile");

function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  const chunk = 0x8000;
  for (let offset = 0; offset < bytes.length; offset += chunk) {
    binary += String.fromCharCode(...bytes.subarray(offset, Math.min(offset + chunk, bytes.length)));
  }
  return btoa(binary);
}

export async function saveBytesToUserDownloads(bytes: Uint8Array, fileName: string, mimeType: string): Promise<string> {
  if (!bytes.length) throw new Error("EMPTY_FILE");
  const data = bytesToBase64(bytes);
  if (Capacitor.isNativePlatform()) {
    if (Capacitor.getPlatform() === "android") {
      // Android must use MediaStore through the native plugin. Do not silently
      // fall back to an app-private folder: the user must receive a real file
      // in the public Download/Mundely directory.
      const result = await NativeFile.saveBase64ToDownloads({ fileName, mimeType, data });
      const path = String(result.path || result.uri || "").trim();
      if (!path) throw new Error("ANDROID_DOWNLOAD_PATH_MISSING");
      if (typeof result.bytes === "number" && result.bytes !== bytes.length) throw new Error("ANDROID_DOWNLOAD_SIZE_MISMATCH");
      return path;
    }

    await Filesystem.writeFile({
      path: `Mundely/${fileName}`,
      data,
      directory: Directory.Documents,
      recursive: true
    });
    return `Documents/Mundely/${fileName}`;
  }
  throw new Error("NATIVE_DOWNLOAD_UNAVAILABLE");
}

export async function saveTextToUserDownloads(content: string, fileName: string, mimeType: string): Promise<string> {
  return saveBytesToUserDownloads(new TextEncoder().encode(content), fileName, mimeType);
}
